import React, { useMemo } from "react";

import CustomAutoCompleteFilter from "../../lib/components/customdatagridfilter/CustomFilter";

import DeleteIcon from "@material-ui/icons/Delete";
import TextEditor from "../../lib/components/TextEditor";
import { SummaryNumber, SummaryNumber2Decimal, SummaryTotal } from "../../lib/components/SummaryFormatter";
import { handleColumnsArrangement, handleColumnsWidth } from "../../lib/helpers/grid";

import Checkbox from "@material-ui/core/Checkbox";
import { DatePicker } from "../../lib/components/gridcustomedit";

import Tooltip from "@material-ui/core/Tooltip";
import CheckIcon from "@material-ui/icons/Check";
import { EnquiryLink, Selector } from "../../lib/components/EnquiryLink";
import DropdownEditor from "../../lib/components/DropdownEditor";
import { FormatterNumber, FormatterNumber2Decimals, DateFormatter } from "../../lib/components/Formatters";

const cellWidthSmall = 65;
const cellWidthMedium = 100;
const cellWidthLarge = 170;

const defaultColumnProperties = {
  filterable: true,
  resizable: true,
  sortable: true,
};

let currentSpace = true;

const CheckboxComp = ({ row, selected, handleChange }) => {
  const checked = useMemo(() => selected[row.Barcode], []);

  return (
    <div style={{ display: "flex", width: "100%", height: "100%", justifyContent: "center", alignItems: "center" }}>
      <Checkbox checked={checked} onChange={(_, value) => handleChange(value, row)} inputProps={{ "aria-label": "primary checkbox" }} style={{ padding: 0 }} />
    </div>
  );
};

export const GridColumns = (data, filters, arrangement, columnsWidth, selected, handleToggleCheckbox, producersList) => {
  let postValue = "";

  if (data) {
    if (currentSpace) {
      postValue = " ";
    }
    currentSpace = !currentSpace;
  }

  const columns = [
    {
      key: "",
      name: " " + postValue,
      width: cellWidthSmall,
      formatter: ({ row }) => <CheckboxComp row={row} selected={selected} handleChange={handleToggleCheckbox} />,
    },
    {
      key: "editable",
      name: "Rejected" + postValue,
      width: cellWidthSmall,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"editable"} data={data} section="stockadjustment" />;
      },
      formatter: ({ row }) =>
        !row.editable ? (
          <div style={{ display: "flex", width: "100%", height: "100%", justifyContent: "center", alignItems: "center" }}>
            <Tooltip title="Rejected">
              <CheckIcon color="error" />
            </Tooltip>
          </div>
        ) : (
          <div></div>
        ),
    },
    {
      key: "Orig Intake Waybill",
      name: "Original Intake Waybill" + postValue,
      width: cellWidthLarge,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Orig Intake Waybill"} data={data} section="stockadjustment" />;
      },
      editable: (row) => (row.can_adjust && row.editable ? true : false),
      editor: TextEditor,
    },
    {
      key: "Intake Waybill",
      name: "Intake Waybill" + postValue,
      width: cellWidthLarge,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Intake Waybill"} data={data} section="stockadjustment" />;
      },
      editable: (row) => (row.can_adjust && row.editable ? true : false),
      editor: TextEditor,
    },
    {
      key: "Barcode",
      name: "Barcode" + postValue,
      width: cellWidthLarge,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Barcode"} data={data} section="stockadjustment" />;
      },
      editable: (row) => (row.can_adjust && row.editable ? true : false),
      editor: TextEditor,
      summaryFormatter: SummaryTotal,
      formatter: (props) => <EnquiryLink {...props} selector={Selector.Barcode} />,
    },
    {
      key: "Producer ID",
      name: "Producer" + postValue,
      width: cellWidthMedium,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Producer ID"} data={data} section="stockadjustment" />;
      },
      editable: (row) => (row.can_adjust && row.editable ? true : false),
      editor: (props) => <DropdownEditor {...props} options={producersList} displayKey="display" valueKey={"value"} />,
    },
    {
      key: "Farm Number",
      name: "PUC" + postValue,
      width: cellWidthSmall,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Farm Number"} data={data} section="stockadjustment" />;
      },
      editable: (row) => (row.can_adjust && row.editable ? true : false),
      editor: TextEditor,
    },
    {
      key: "Location Code",
      name: "Location" + postValue,
      width: cellWidthSmall,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Location Code"} data={data} section="stockadjustment" />;
      },
      editable: (row) => (row.can_adjust && row.editable ? true : false),
      editor: TextEditor,
    },
    {
      key: "age",
      name: "Age" + postValue,
      width: cellWidthSmall,
      formatter: FormatterNumber,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"age"} data={data} section="stockadjustment" />;
      },
    },
    {
      key: "ageAtLocation",
      name: "Age@Loc" + postValue,
      width: cellWidthSmall,
      formatter: FormatterNumber,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"ageAtLocation"} data={data} section="stockadjustment" />;
      },
    },
    {
      key: "Commodity Code",
      name: "Commodity" + postValue,
      width: cellWidthSmall,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Commodity Code"} data={data} section="stockadjustment" />;
      },
      editable: (row) => (row.can_adjust && row.editable ? true : false),
      editor: TextEditor,
    },
    {
      key: "Variety Code",
      name: "Variety" + postValue,
      width: cellWidthSmall,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Variety Code"} data={data} section="stockadjustment" />;
      },
      editable: (row) => (row.can_adjust && row.editable ? true : false),
      editor: TextEditor,
    },
    {
      key: "Target Region",
      name: "TR" + postValue,
      width: cellWidthSmall,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Target Region"} data={data} section="stockadjustment" />;
      },
      editable: (row) => (row.can_adjust && row.editable ? true : false),
      editor: TextEditor,
    },
    {
      key: "Target Market",
      name: "TM" + postValue,
      width: cellWidthSmall,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Target Market"} data={data} section="stockadjustment" />;
      },
      editable: (row) => (row.can_adjust && row.editable ? true : false),
      editor: TextEditor,
    },
    {
      key: "Target Country",
      name: "TC" + postValue,
      width: cellWidthSmall,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Target Country"} data={data} section="stockadjustment" />;
      },
      editable: (row) => (row.can_adjust && row.editable ? true : false),
      editor: TextEditor,
    },
    {
      key: "Grade Code",
      name: "Grade" + postValue,
      width: cellWidthSmall,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Grade Code"} data={data} section="stockadjustment" />;
      },
      editable: (row) => (row.can_adjust && row.editable ? true : false),
      editor: (props) => <TextEditor {...props} align="right" />,
    },
    {
      key: "Count Code",
      name: "Count" + postValue,
      width: cellWidthSmall,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Count Code"} data={data} section="stockadjustment" />;
      },
      editable: (row) => (row.can_adjust && row.editable ? true : false),
      editor: (props) => <TextEditor {...props} align="right" />,
    },
    {
      key: "Pack Code",
      name: "Pack" + postValue,
      width: cellWidthSmall,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Pack Code"} data={data} section="stockadjustment" />;
      },
      editable: (row) => (row.can_adjust && row.editable ? true : false),
      editor: TextEditor,
    },
    {
      key: "Mark Code",
      name: "Mark" + postValue,
      width: cellWidthSmall,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Mark Code"} data={data} section="stockadjustment" />;
      },
      editable: (row) => (row.can_adjust && row.editable ? true : false),
      editor: TextEditor,
    },
    {
      key: "Inventory Code",
      name: "Inv Code" + postValue,
      width: cellWidthSmall,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Inventory Code"} data={data} section="stockadjustment" />;
      },
      editable: (row) => (row.can_adjust && row.editable ? true : false),
      editor: TextEditor,
    },
    {
      key: "Picking Ref",
      name: "Picking Ref" + postValue,
      width: cellWidthSmall,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Picking Ref"} data={data} section="stockadjustment" />;
      },
      editable: (row) => (row.can_adjust && row.editable ? true : false),
      editor: TextEditor,
    },
    {
      key: "Orchard",
      name: "Orchard" + postValue,
      width: cellWidthSmall,
      editable: (row) => (row.can_adjust && row.editable ? true : false),
      editor: TextEditor,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Orchard"} data={data} section="stockadjustment" />;
      },
    },
    {
      key: "PHC",
      name: "phc" + postValue,
      width: cellWidthSmall,
      editable: (row) => (row.can_adjust && row.editable ? true : false),
      editor: TextEditor,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"PHC"} data={data} section="stockadjustment" />;
      },
    },
    {
      key: "Weight",
      name: "Net Weight",
      width: cellWidthSmall,
      formatter: FormatterNumber2Decimals,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Weight"} data={data} section="stockadjustment" />;
      },
      summaryFormatter: SummaryNumber2Decimal,
    },
    {
      key: "Gross Weight",
      name: "Gross Weight",
      width: cellWidthSmall,
      formatter: FormatterNumber2Decimals,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Gross Weight"} data={data} section="stockadjustment" />;
      },
      editable: (row) => (row.can_adjust && row.editable ? true : false),
      editor: (props) => <TextEditor {...props} align="right" />,
      summaryFormatter: SummaryNumber2Decimal,
    },
    {
      key: "Product Group",
      name: "Product Group" + postValue,
      width: cellWidthSmall,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Product Group"} data={data} section="stockadjustment" />;
      },
      editable: (row) => (row.can_adjust && row.editable ? true : false),
      editor: TextEditor,
    },
    {
      key: "Product Char",
      name: "Product Character" + postValue,
      width: cellWidthSmall,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Product Char"} data={data} section="stockadjustment" />;
      },
      editable: (row) => (row.can_adjust && row.editable ? true : false),
      editor: TextEditor,
    },
    {
      key: "BatchNumber",
      name: "Batch No" + postValue,
      width: cellWidthSmall,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"BatchNumber"} data={data} section="stockadjustment" />;
      },
      editable: (row) => (row.can_adjust && row.editable ? true : false),
      editor: TextEditor,
    },
    {
      key: "No Cartons",
      name: "no Cartons" + postValue,
      width: cellWidthSmall,
      formatter: FormatterNumber,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"No Cartons"} data={data} section="stockadjustment" />;
      },
      editable: (row) => (row.can_adjust && row.editable ? true : false),
      editor: (props) => <TextEditor {...props} align="right" />,
      summaryFormatter: SummaryNumber,
    },
    {
      key: "Pallet Size",
      name: "PalletSize" + postValue,
      width: cellWidthSmall,
      formatter: FormatterNumber2Decimals,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Pallet Size"} data={data} section="stockadjustment" />;
      },
      editable: (row) => (row.can_adjust && row.editable ? true : false),
      editor: (props) => <TextEditor {...props} align="right" />,
      summaryFormatter: SummaryNumber2Decimal,
    },
    {
      key: "shippedMarket",
      name: "SM" + postValue,
      width: cellWidthSmall,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"shippedMarket"} data={data} section="stockadjustment" />;
      },
    },
    {
      key: "Inspector Name",
      name: "Inspector Code" + postValue,
      width: cellWidthSmall,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Inspector Name"} data={data} section="stockadjustment" />;
      },
      editable: (row) => (row.can_adjust && row.editable ? true : false),
      editor: TextEditor,
    },
    {
      key: "Inspection Point",
      name: "Inspection Point" + postValue,
      width: cellWidthSmall,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Inspection Point"} data={data} section="stockadjustment" />;
      },
      editable: (row) => (row.can_adjust && row.editable ? true : false),
      editor: TextEditor,
    },
    {
      key: "Inspection Date",
      name: "Inspection Date" + postValue,
      width: cellWidthLarge,
      editor: DatePicker,
      editable: (row) => (row.can_adjust && row.editable ? true : false),
      formatter: DateFormatter,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Inspection Date"} data={data} section="stockadjustment" />;
      },
    },
    {
      key: "UPN",
      name: "UPN" + postValue,
      width: cellWidthSmall,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"UPN"} data={data} section="stockadjustment" />;
      },
      editable: (row) => (row.can_adjust && row.editable ? true : false),
      editor: TextEditor,
    },
    {
      key: "Ref No",
      name: "Load Ref" + postValue,
      width: cellWidthMedium,
      editor: TextEditor,
      editable: (row) => (row.can_adjust && row.editable ? true : false),
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Ref No"} data={data} section="stockadjustment" includeempty={true} />;
      },
    },
    {
      key: "invoice_numbers",
      name: "Invoice Number(s)" + postValue,
      width: cellWidthSmall,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"invoice_numbers"} data={data} section="stockadjustment" />;
      },
    },
    {
      key: "clients_name",
      name: "Client Name" + postValue,
      width: cellWidthSmall,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"clients_name"} data={data} section="stockadjustment" />;
      },
    },
    {
      key: "consignee_name",
      name: "Consignee Name" + postValue,
      width: cellWidthSmall,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"consignee_name"} data={data} section="stockadjustment" />;
      },
    },
    {
      key: "clientorderno",
      name: "Client Order No" + postValue,
      width: cellWidthSmall,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"clientorderno"} data={data} section="stockadjustment" />;
      },
    },
    {
      key: "vessel_description",
      name: "Vessel" + postValue,
      width: cellWidthMedium,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"vessel_description"} data={data} section="stockadjustment" />;
      },
    },
    {
      key: "dispatch_containerno",
      name: "Container No" + postValue,
      width: cellWidthMedium,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"dispatch_containerno"} data={data} section="stockadjustment" />;
      },
    },
    {
      key: "port_loading",
      name: "Port of Loading" + postValue,
      width: cellWidthMedium,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"port_loading"} data={data} section="stockadjustment" />;
      },
    },
    {
      key: "port_discharge",
      name: "Port of Discharge" + postValue,
      width: cellWidthMedium,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"port_discharge"} data={data} section="stockadjustment" />;
      },
    },
    {
      key: "port_final",
      name: "Final Destination" + postValue,
      width: cellWidthMedium,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"port_final"} data={data} section="stockadjustment" />;
      },
    },
    {
      key: "loadout_etd",
      name: "ETD" + postValue,
      width: cellWidthMedium,
      formatter: DateFormatter,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"loadout_etd"} data={data} section="stockadjustment" />;
      },
    },
    {
      key: "loadout_eta",
      name: "ETA" + postValue,
      width: cellWidthMedium,
      formatter: DateFormatter,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"loadout_eta"} data={data} section="stockadjustment" />;
      },
    },
    {
      key: "loadout_updated_eta",
      name: "Updated ETA" + postValue,
      width: cellWidthMedium,
      formatter: DateFormatter,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"loadout_updated_eta"} data={data} section="stockadjustment" />;
      },
    },
    {
      key: "intakeWeek",
      name: "Intake Week" + postValue,
      width: cellWidthSmall,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"intakeWeek"} data={data} section="stockadjustment" />;
      },
    },
    {
      key: "coldWeek",
      name: "Cold Week" + postValue,
      width: cellWidthSmall,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"coldWeek"} data={data} section="stockadjustment" />;
      },
    },
    {
      key: "Cold Date",
      name: "Cold Date",
      width: cellWidthLarge,
      editor: DatePicker,
      editable: (row) => (row.can_adjust && row.editable ? true : false),
      formatter: DateFormatter,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Cold Date"} data={data} section="stockadjustment" />;
      },
    },
    {
      key: "inspectionAge",
      name: "Insp Age",
      width: cellWidthSmall,
      formatter: FormatterNumber,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"inspectionAge"} data={data} section="stockadjustment" />;
      },
    },
    {
      key: "Orig Intake Date",
      name: "Org Intake Date",
      width: cellWidthLarge,
      editor: DatePicker,
      editable: (row) => (row.can_adjust && row.editable ? true : false),
      formatter: DateFormatter,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Orig Intake Date"} data={data} section="stockadjustment" />;
      },
    },
    {
      key: "Purchase Price",
      name: "Purchase Price",
      width: cellWidthSmall,
      editable: (row) => (row.can_adjust && row.editable ? true : false),
      editor: (props) => <TextEditor {...props} align="right" />,
      formatter: FormatterNumber2Decimals,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Purchase Price"} data={data} section="stockadjustment" />;
      },
    },
    {
      key: "Temperature",
      name: "Temperature",
      width: cellWidthSmall,
      editable: (row) => (row.can_adjust && row.editable ? true : false),
      editor: (props) => <TextEditor {...props} align="right" />,
      formatter: FormatterNumber,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Temperature"} data={data} section="stockadjustment" />;
      },
    },
    {
      key: "UserName",
      name: "UserName" + postValue,
      width: cellWidthSmall,
      editable: (row) => (row.can_adjust && row.editable ? true : false),
      editor: TextEditor,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"UserName"} data={data} section="stockadjustment" />;
      },
    },
    {
      key: "Trader ID",
      name: "Trader" + postValue,
      width: cellWidthSmall,
      editable: (row) => (row.can_adjust && row.editable ? true : false),
      editor: TextEditor,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Trader ID"} data={data} section="stockadjustment" />;
      },
    },
    {
      key: "Organization",
      name: "Org" + postValue,
      width: cellWidthSmall,
      editable: (row) => (row.can_adjust && row.editable ? true : false),
      editor: TextEditor,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Organization"} data={data} section="stockadjustment" />;
      },
    },
    {
      key: "Date Entered",
      name: "Date Entered",
      width: cellWidthLarge,
      editor: DatePicker,
      editable: (row) => (row.can_adjust && row.editable ? true : false),
      formatter: DateFormatter,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Date Entered"} data={data} section="stockadjustment" />;
      },
    },
    {
      key: "Phyto Verification",
      name: "Phyto Verification",
      width: cellWidthMedium,
      editable: (row) => (row.can_adjust && row.editable ? true : false),
      editor: TextEditor,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Phyto Verification"} data={data} section="stockadjustment" />;
      },
    },
    {
      key: "year",
      name: "Year" + postValue,
      width: cellWidthSmall,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"year"} data={data} section="stockadjustment" />;
      },
    },
    {
      key: "Channel",
      name: "Channel" + postValue,
      width: cellWidthSmall,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Channel"} data={data} section="stockadjustment" />;
      },
      editable: (row) => (row.can_adjust && row.editable ? true : false),
      editor: TextEditor,
    },
    {
      key: "reject_note",
      name: "Reject Reason",
      width: cellWidthMedium,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"reject_note"} data={data} section="stockadjustment" />;
      },
    },
    {
      key: "Agent",
      name: "Agent" + postValue,
      width: cellWidthSmall,
      filterable: true,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Agent"} data={data} section="stockadjustment" />;
      },
    },
    {
      key: "characteristic_description",
      name: "Agent Description" + postValue,
      width: cellWidthLarge,
      filterable: true,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"characteristic_description"} data={data} section="stockadjustment" />;
      },
    },
    // {
    //   key: "sellp",
    //   name: "Selling Price" + postValue,
    //   width: cellWidthSmall,
    //   editable: (row) => row.can_adjust && row.editable ? true : false,
    //   editor: (props) => <TextEditor {...props} align="right" />,
    //   formatter: FormatterNumber2Decimals,
    //   filterRenderer: (e) => {
    //     return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"sellp"} data={data} section="stockadjustment" />;
    //   },
    // },
    // {
    //   key: "tempcode",
    //   name: "Temp Code" + postValue,
    //   editor: TextEditor,
    //   editable: (row) => row.can_adjust && row.editable ? true : false,
    //   width: cellWidthMedium,
    //   filterRenderer: (e) => {
    //     return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"tempcode"} data={data} section="stockadjustment" />;
    //   },
    // },
    // {
    //   key: "po",
    //   name: "PO Number" + postValue,
    //   width: cellWidthMedium,
    //   editor: TextEditor,
    //   editable: (row) => row.can_adjust && row.editable ? true : false,
    //   filterRenderer: (e) => {
    //     return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"po"} data={data} section="stockadjustment" />;
    //   },
    // },
    // {
    //   key: "pod",
    //   name: "POD" + postValue,
    //   width: cellWidthMedium,
    //   editor: TextEditor,
    //   editable: (row) => row.can_adjust && row.editable ? true : false,
    //   filterRenderer: (e) => {
    //     return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"pod"} data={data} section="stockadjustment" />;
    //   },
    // },
    // {
    //   key: "consigneeName",
    //   name: "Consignee Name" + postValue,
    //   width: cellWidthSmall,
    //   editable: (row) => row.can_adjust && row.editable ? true : false,
    //   editor: TextEditor,
    //   filterRenderer: (e) => {
    //     return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"consigneeName"} data={data} section="stockadjustment" />;
    //   },
    // },
  ].map((c) => ({ ...c, ...defaultColumnProperties }));

  let columnsArranged = [];
  columnsArranged = handleColumnsArrangement(columnsArranged, arrangement, columns);
  columnsArranged = handleColumnsWidth(columnsArranged, columnsWidth, columns);

  return columnsArranged;
};
